/**
 * Subscription-Widget: Ganze Card klickbar, "OR"/"ODER" übersetzt einfügen.
 * Unterstützt alte Struktur (app_block_label) und neue App-Block-Struktur (plan_card, subscription_group).
 */
(function () {
  function isNewStructure() {
    const visibleBlock = document.querySelector('section.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden)');
    return !!(visibleBlock && visibleBlock.querySelector('.plan_card'));
  }

  function getWrapper() {
    if (isNewStructure()) {
      var card = document.querySelector('section.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden) .plan_card');
      if (card) return card;
      card = document.querySelector('#MainContent .shopify_subscriptions_app_container .plan_card');
      if (card) return card;
      var sections = document.querySelectorAll('#MainContent .shopify_subscriptions_app_container section.shopify_subscriptions_app_block');
      for (var i = 0; i < sections.length; i++) {
        var style = window.getComputedStyle(sections[i]);
        if (style.display !== 'none' && style.visibility !== 'hidden') {
          var c = sections[i].querySelector('.plan_card');
          if (c) return c;
        }
      }
    }
    return document.querySelector(
      'div:has(> .shopify_subscriptions_app_block_label.shopify_subscriptions_purchase_option_wrapper)'
    );
  }

  function getOneTimeCard() {
    if (isNewStructure()) {
      const planCard = getWrapper();
      return planCard ? planCard.querySelector('.subscription_group:nth-child(1)') : null;
    }
    return document.querySelector(
      '.shopify_subscriptions_app_block_label.shopify_subscriptions_purchase_option_wrapper'
    );
  }

  function getAboBlock() {
    if (isNewStructure()) {
      const planCard = getWrapper();
      return planCard ? planCard.querySelector('.subscription_group:nth-child(2)') : null;
    }
    return document.querySelector(
      '.shopify_subscriptions_app_block_label:not(.shopify_subscriptions_purchase_option_wrapper)'
    );
  }

  function injectOrDivider() {
    const orText = document.body.getAttribute('data-subscription-or') || 'OR';
    const wrapper = getWrapper();
    if (!wrapper || wrapper.querySelector('.subscription-widget-or')) return;

    const divider = document.createElement('div');
    divider.className = 'subscription-widget-or';
    divider.setAttribute('aria-hidden', 'true');
    divider.textContent = orText;

    if (isNewStructure()) {
      var groups = wrapper.querySelectorAll('.subscription_group');
      var secondGroup = groups[1] || null;
      if (secondGroup) {
        secondGroup.insertAdjacentElement('afterend', divider);
      } else {
        wrapper.appendChild(divider);
      }
    } else {
      wrapper.appendChild(divider);
    }
  }

  function isSubscriptionSelectedInDOM() {
    return !!document.querySelector(
      'input[type="radio"][data-radio-type="selling_plan"]:checked'
    );
  }

  function dispatchPurchaseOptionChange() {
    document.dispatchEvent(
      new CustomEvent('subscription-widget:change', {
        detail: { subscription: isSubscriptionSelectedInDOM() }
      })
    );
  }

  function selectDefaultSubscription() {
    if (isNewStructure()) {
      var visibleCard = document.querySelector('section.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden) .plan_card') ||
        document.querySelector('#MainContent .shopify_subscriptions_app_container .plan_card');
      if (!visibleCard) return;
      var firstPlanRadio = visibleCard.querySelector('input[type="radio"][data-radio-type="selling_plan"]');
      var oneTimeRadio = visibleCard.querySelector('input[type="radio"][data-radio-type="one_time_purchase"]');
      if (firstPlanRadio) {
        firstPlanRadio.checked = true;
        if (oneTimeRadio) oneTimeRadio.checked = false;
        firstPlanRadio.dispatchEvent(new Event('change', { bubbles: true }));
        updateSubscriptionBadgeVisibility();
        updateSavingsBadge();
        dispatchPurchaseOptionChange();
      }
      return;
    }
    var aboBlock = document.querySelector('.shopify_subscriptions_app_block_label:not(.shopify_subscriptions_purchase_option_wrapper)');
    if (!aboBlock) return;
    var firstPlanRadio = aboBlock.querySelector('input[type="radio"][data-radio-type="selling_plan"]');
    if (firstPlanRadio) {
      firstPlanRadio.checked = true;
      var oneTimeRadio = document.querySelector('input[type="radio"][data-radio-type="one_time_purchase"]');
      if (oneTimeRadio) oneTimeRadio.checked = false;
      firstPlanRadio.dispatchEvent(new Event('change', { bubbles: true }));
      dispatchPurchaseOptionChange();
    }
  }

  function injectSubscriptionBadge() {
    const badgeText = document.body.getAttribute('data-subscription-badge') || 'Flexible subscription + 30-day money-back guarantee';

    var planCards = document.querySelectorAll('#MainContent .shopify_subscriptions_app_container .plan_card, #MainContent section.shopify_subscriptions_app_block .plan_card');
    if (planCards.length > 0) {
      planCards.forEach(function (card) {
        if (card.querySelector('.subscription-widget-badge')) return;
        var aboGroup = card.querySelector('.subscription_group .group_list');
        if (!aboGroup) return;
        var badge = document.createElement('div');
        badge.className = 'subscription-widget-badge';
        badge.setAttribute('aria-hidden', 'true');
        badge.textContent = '🤩 ' + badgeText;
        card.insertBefore(badge, card.firstChild);
      });
      updateSubscriptionBadgeVisibility();
      return;
    }

    var wrapper = document.querySelector('div:has(> .shopify_subscriptions_app_block_label.shopify_subscriptions_purchase_option_wrapper)');
    if (!wrapper || wrapper.querySelector('.subscription-widget-badge')) return;
    var aboBlock = document.querySelector('.shopify_subscriptions_app_block_label:not(.shopify_subscriptions_purchase_option_wrapper)');
    if (!aboBlock) return;

    var badge = document.createElement('div');
    badge.className = 'subscription-widget-badge';
    badge.setAttribute('aria-hidden', 'true');
    badge.textContent = '🤩 ' + badgeText;
    wrapper.insertBefore(badge, wrapper.firstChild);
    updateSubscriptionBadgeVisibility();
  }

  function updateSubscriptionBadgeVisibility() {
    var isSubscriptionSelected = !!document.querySelector(
      'input[type="radio"][data-radio-type="selling_plan"]:checked'
    );
    var badges = document.querySelectorAll('#MainContent .subscription-widget-badge, .subscription-widget-badge');
    if (badges.length > 0) {
      badges.forEach(function (badge) {
        badge.classList.toggle('subscription-widget-badge--visible', isSubscriptionSelected);
      });
      return;
    }
    var wrapper = getWrapper();
    if (!wrapper) return;
    var badge = wrapper.querySelector('.subscription-widget-badge');
    if (!badge) return;
    badge.classList.toggle('subscription-widget-badge--visible', isSubscriptionSelected);
  }

  function parsePriceString(str) {
    if (!str || typeof str !== 'string') return null;
    var match = str.replace(/,/g, '.').match(/[\d]+\.?[\d]*/);
    return match ? parseFloat(match[0], 10) : null;
  }

  function injectSavingsBadge() {
    const aboBlock = getAboBlock();
    if (!aboBlock) return;
    let insertParent;
    if (isNewStructure()) {
      const headerWrapper = aboBlock.querySelector('.title_and_price_wrapper');
      if (!headerWrapper || headerWrapper.querySelector('.subscription-widget-savings')) return;
      insertParent = headerWrapper;
    } else {
      const headerWrapper = aboBlock.querySelector('.shopify_subscriptions_purchase_option_wrapper');
      if (!headerWrapper || headerWrapper.querySelector('.subscription-widget-savings')) return;
      const priceEl = headerWrapper.querySelector('.shopify_subscriptions_in_widget_price');
      if (!priceEl) return;
      insertParent = priceEl.parentNode;
    }

    const savingsEl = document.createElement('span');
    savingsEl.className = 'subscription-widget-savings';
    savingsEl.setAttribute('aria-hidden', 'true');
    if (isNewStructure()) {
      insertParent.appendChild(savingsEl);
    } else {
      const priceEl = insertParent.querySelector('.shopify_subscriptions_in_widget_price');
      insertParent.insertBefore(savingsEl, priceEl ? priceEl.nextSibling : null);
    }
    updateSavingsBadge();
  }

  function updateSavingsBadge() {
    const savePrefix = document.body.getAttribute('data-subscription-save-prefix') || 'Save';
    const savePercentSuffix = document.body.getAttribute('data-subscription-save-percent') || '% off';
    const aboBlock = getAboBlock();
    if (!aboBlock) return;
    const savingsEl = aboBlock.querySelector('.subscription-widget-savings');
    if (!savingsEl) return;

    /* Ersparnis immer anzeigen (auch bei Einmalkauf ausgewählt) – nutze ersten Abo-Plan für die Berechnung */
    var planRadio = aboBlock.querySelector(
      'input[type="radio"][data-radio-type="selling_plan"]:checked'
    ) || aboBlock.querySelector(
      'input[type="radio"][data-radio-type="selling_plan"]'
    );
    if (!planRadio) {
      savingsEl.textContent = '';
      savingsEl.classList.remove('subscription-widget-savings--visible');
      return;
    }

    var text = '';
    var labelText = (planRadio.closest('label') && planRadio.closest('label').textContent) || '';
    var percentMatch = labelText.match(/(\d+)\s*%\s*off/i) || labelText.match(/(\d+)\s*%\s*Ersparnis/i);
    if (percentMatch) {
      text = percentMatch[1] + ' ' + savePercentSuffix;
    } else {
      var compareAt = planRadio.getAttribute('data-variant-compare-at-price');
      var subscriptionPrice = planRadio.getAttribute('data-variant-price');
      var oneTimePriceEl = isNewStructure()
        ? (getOneTimeCard() && getOneTimeCard().querySelector('.in_widget_price'))
        : document.querySelector(
            '.shopify_subscriptions_app_block_label.shopify_subscriptions_purchase_option_wrapper .shopify_subscriptions_in_widget_price'
          );
      var oneTimePriceStr = oneTimePriceEl ? oneTimePriceEl.textContent : '';
      var originalPrice = parsePriceString(compareAt || oneTimePriceStr);
      var subscriptionPriceNum = parsePriceString(subscriptionPrice);
      if (originalPrice != null && subscriptionPriceNum != null && originalPrice > subscriptionPriceNum) {
        var diff = originalPrice - subscriptionPriceNum;
        var currencyMatch = oneTimePriceStr.match(/^([$€£])\s*/) || oneTimePriceStr.match(/^([^\d]*)/);
        var currency = (currencyMatch && currencyMatch[1]) ? currencyMatch[1].trim() : '';
        var amountStr = diff % 1 === 0 ? String(diff) : diff.toFixed(2);
        text = savePrefix + ' ' + currency + amountStr;
      }
    }
    if (text) {
      savingsEl.textContent = text;
      savingsEl.classList.add('subscription-widget-savings--visible');
    } else {
      savingsEl.textContent = '';
      savingsEl.classList.remove('subscription-widget-savings--visible');
    }
  }

  function hideAutoRenewsText() {
    var wrapper = getWrapper();
    if (!wrapper) return;
    var container = wrapper.closest('form') || wrapper.parentElement;
    if (!container) return;
    var candidates = container.querySelectorAll('p, span, div');
    var toHide = null;
    var minLen = Infinity;
    for (var i = 0; i < candidates.length; i++) {
      var text = (candidates[i].textContent || '').trim();
      if (/Auto-renews|skip or cancel|cancel anytime|Verlängert sich automatisch|jederzeit kündbar/i.test(text)) {
        if (text.length < minLen && text.length < 200) {
          minLen = text.length;
          toHide = candidates[i];
        }
      }
    }
    if (toHide) toHide.style.display = 'none';
  }

  function translateSubscriptionLabel() {
    const labelText = document.body.getAttribute('data-subscription-subscribe-and-save') || 'Subscribe and save';
    const aboBlock = getAboBlock();
    if (!aboBlock) return;
    if (isNewStructure()) {
      const groupName = aboBlock.querySelector('.group_name');
      if (groupName) groupName.textContent = labelText;
      return;
    }
    const headerWrapper = aboBlock.querySelector('.shopify_subscriptions_purchase_option_wrapper');
    if (!headerWrapper) return;
    const labels = headerWrapper.querySelectorAll('label');
    for (let i = 0; i < labels.length; i++) {
      if (!labels[i].querySelector('input')) {
        labels[i].textContent = labelText;
        break;
      }
    }
  }

  function init() {
    injectOrDivider();
    translateSubscriptionLabel();
    injectSubscriptionBadge();
    injectSavingsBadge();
    selectDefaultSubscription();
    updateSubscriptionBadgeVisibility();
    updateSavingsBadge();
    hideAutoRenewsText();

    var wrapper = getWrapper();
    if (wrapper && !wrapper._subscriptionWidgetListeners) {
      wrapper._subscriptionWidgetListeners = true;
      wrapper.addEventListener('change', function () {
        updateSubscriptionBadgeVisibility();
        updateSavingsBadge();
        dispatchPurchaseOptionChange();
      });
    }

    document.addEventListener('click', function (e) {
      const target = e.target;

      /* Einmaliger-Kauf-Card: Klick setzt One-time-Radio */
      const firstGroup = document.querySelector('section.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden) .plan_card .subscription_group:nth-child(1)');
      const oneTimeCard = (firstGroup && firstGroup.contains(target))
        ? firstGroup
        : target.closest('.shopify_subscriptions_app_block_label.shopify_subscriptions_purchase_option_wrapper');
      if (oneTimeCard) {
        const radio = oneTimeCard.querySelector(
          'input[type="radio"][data-radio-type="one_time_purchase"]'
        );
        if (radio && target.tagName !== 'INPUT') {
          e.preventDefault();
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          updateSubscriptionBadgeVisibility();
          updateSavingsBadge();
          dispatchPurchaseOptionChange();
          return;
        }
      }

      /* Abo-Card Header: Klick wählt erste Abo-Option */
      if (isNewStructure()) {
        const aboBlock = getAboBlock();
        const clickedAboHeader = aboBlock && target.closest('.subscription_group:nth-child(2) .title_and_price_wrapper:first-of-type');
        if (clickedAboHeader && target.tagName !== 'INPUT') {
          const firstPlanRadio = aboBlock.querySelector(
            'ul input[type="radio"][data-radio-type="selling_plan"]'
          );
          if (firstPlanRadio) {
            e.preventDefault();
            firstPlanRadio.checked = true;
            firstPlanRadio.dispatchEvent(new Event('change', { bubbles: true }));
            updateSubscriptionBadgeVisibility();
            updateSavingsBadge();
            dispatchPurchaseOptionChange();
            return;
          }
        }
      } else {
        const purchaseWrapper = target.closest('.shopify_subscriptions_purchase_option_wrapper');
        if (purchaseWrapper) {
          const parentLabel = purchaseWrapper.closest('.shopify_subscriptions_app_block_label');
          if (
            parentLabel &&
            !parentLabel.classList.contains('shopify_subscriptions_purchase_option_wrapper')
          ) {
            const firstPlanRadio = parentLabel.querySelector(
              'ul input[type="radio"][data-radio-type="selling_plan"]'
            );
            if (firstPlanRadio && target.tagName !== 'INPUT') {
              e.preventDefault();
              firstPlanRadio.checked = true;
              firstPlanRadio.dispatchEvent(new Event('change', { bubbles: true }));
              updateSubscriptionBadgeVisibility();
              updateSavingsBadge();
              dispatchPurchaseOptionChange();
              return;
            }
          }
        }
      }
    });
  }

  function runDelayedInjection() {
    injectOrDivider();
    translateSubscriptionLabel();
    injectSubscriptionBadge();
    injectSavingsBadge();
    selectDefaultSubscription();
    updateSubscriptionBadgeVisibility();
    updateSavingsBadge();
    hideAutoRenewsText();
    var wrapper = getWrapper();
    if (wrapper && !wrapper._subscriptionWidgetListeners) {
      wrapper._subscriptionWidgetListeners = true;
      wrapper.addEventListener('change', function () {
        updateSubscriptionBadgeVisibility();
        updateSavingsBadge();
        dispatchPurchaseOptionChange();
      });
    }
  }

  function run() {
    init();
    runDelayedInjection();
    [500, 1500, 3000].forEach(function (delay) {
      setTimeout(runDelayedInjection, delay);
    });
    [600, 1200].forEach(function (delay) {
      setTimeout(function () {
        selectDefaultSubscription();
        updateSubscriptionBadgeVisibility();
        updateSavingsBadge();
      }, delay);
    });
    var main = document.getElementById('MainContent');
    if (main && typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function (mutations) {
        var hasPlanCard = false;
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.classList && node.classList.contains('plan_card')) hasPlanCard = true;
            else if (node.querySelector && node.querySelector('.plan_card')) hasPlanCard = true;
          }
        }
        if (hasPlanCard || document.querySelector('#MainContent .plan_card') && !document.querySelector('#MainContent .plan_card .subscription-widget-badge')) {
          runDelayedInjection();
        }
      });
      observer.observe(main, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
